import React, { useState, useEffect } from "react";
import "../../styles/admins/inventory.css";
import axios from "axios";
import Select from "react-select";

function AddUsers(props) {

  const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: 'none',
    boxShadow: 'none',
    '&:hover': {
      border: 'none',
    },
  }),
  // Optional: style the dropdown or menu
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, // keep it on top if needed
  }),
};
 
 const currentUser = props.currentUser;


  const [formData, setFormData] = useState({
    id: props.editUser.id || '',
    olditem_id: props.editUser.item_id || '',
    staff_name: props.editUser.name || "",
    staff_id: props.editUser.staff_id || "",
    pass: props.editUser.pass || "",
    comp_id: props.editUser.company_id ||   props.currentUser?.comp_id || "",
    contact: props.editUser.contact || "",
    email: props.editUser.email || "",
    designation: props.editUser.designation || "",
    department: props.editUser.department || "",
    staff_type: props.editUser.is_admin || "",
    assigned_item: props.editUser.item_id || "",
    assign_date: props.editUser.item_assign_date
      ? props.editUser.item_assign_date.split(" ")[0]
      : "",
      priority: props.editUser.priority || "",
        image: props.editUser.image || null,
  });

  const [companies, setCompanies] = useState([]);
  const [items, setItems] = useState([]);


   const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      image: e.target.files[0],
    }));
  };

  // Fetch companies
  useEffect(() => {
    const getProducts = async () => {
      try {
        const response = await axios.get(
          "https://api.dectwinservices.com/api/products"
        );

             if(props.doEdit == 'Techie'){
     
const filterData = response.data.filter(product => product.added_by == props.currentUser.company_id);
            setItems(filterData);


          // localStorage.setItem("products", JSON.stringify(response.data));
          }
          else {
          setItems(response.data);
          // localStorage.setItem("products", JSON.stringify(response.data));
          }
        // setItems(response.data);
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    const getCompanies = async () => {
      try {
        const response = await axios.get(
          "https://api.dectwinservices.com/api/companies"
        );

           const filteredData = response.data.filter(
      (item) => item.is_active !== 1
    );
        setCompanies(filteredData);
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    getProducts();
    getCompanies();
  }, [props]);

  const unassignedItems = items
  .filter((item) => item.assigned_to == null && item.stats == 'Available')
  .map((item) => ({
    value: item.prod_id,
    label: `${item.name} (Asset Code: ${item.barcode})`
  }));


  // Handle input change
  const handleChange = (e) => {

    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Submit form data
// const handleSubmit = async (e) => {
//   e.preventDefault();


//  const formDataToSend = new FormData();
//     formDataToSend.append("comp_name", formData.comp_name);
 
//     if (formData.image) {
//       formDataToSend.append("image", formData.image);
//     }


//   try {
//     if (Object.keys(props.editUser).length === 0) {
//       await axios.post(
//         "https://api.dectwinservices.com/api/add-user",
//         formData
//       );
//       props.handleToast({
//         toastMsg: "User Added Successfully!!!",
//         toastColor: "#4CAF50",
//       });
//     } else {
//       await axios.put(
//         "https://api.dectwinservices.com/api/update-user",
//         formData
//       );
//       props.handleToast({
//         toastMsg: "User Updated Successfully!!!",
//         toastColor: "#4CAF50",
//       });
//     }

//     localStorage.removeItem("users");
//     setTimeout(() => {
//       window.location.reload();
//     }, 1500);
//   } catch (error) {
//     const msg =
//       error?.response?.data?.message ||
//       "Something went wrong! Please check data or internet.";
//     props.handleToast({
//       toastMsg: msg,
//       toastColor: "#FF0000",
//     });
//   }
// };
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const formDataToSend = new FormData();

    Object.keys(formData).forEach((key) => {
      if (key === "image") {
        if (formData.image instanceof File) {
          formDataToSend.append("image", formData.image);
        }
      } else {
        formDataToSend.append(key, formData[key] ?? "");
      }
    });

    if (Object.keys(props.editUser).length === 0) {
      await axios.post(
        "https://api.dectwinservices.com/api/add-user",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      props.handleToast({
        toastMsg: "User Added Successfully!!!",
        toastColor: "#4CAF50",
      });
    } else {
      await axios.put(
        "https://api.dectwinservices.com/api/update-user",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      props.handleToast({
        toastMsg: "User Updated Successfully!!!",
        toastColor: "#4CAF50",
      });
    }

    localStorage.removeItem("users");

    setTimeout(() => {
      window.location.reload();
    }, 1500);
  } catch (error) {
    const msg =
      error?.response?.data?.message ||
      "Something went wrong! Please check data or internet.";

    props.handleToast({
      toastMsg: msg,
      toastColor: "#FF0000",
    });
  }
};



// const companyOptions =
//   currentUser?.is_admin === "Techie" 
//     ? companies.filter(
//         company => company.comp_id === currentUser.comp_id
//       )
//     : companies;

const userCompanyId =
  currentUser?.comp_id || currentUser?.company_id;
const isRestrictedUser = ["Techie", "Admin"].includes(currentUser?.is_admin);


const companyOptions =
  isRestrictedUser && userCompanyId
    ? companies.filter(
        company =>
          String(company.comp_id).trim() ===
          String(userCompanyId).trim()
      )
    : companies;

//     useEffect(() => {
//   if (currentUser?.is_admin === "Techie") {
//     setFormData(prev => ({
//       ...prev,
//       comp_id: currentUser.comp_id,
//     }));
//   }
// }, [currentUser]);

useEffect(() => {
  const userCompanyId =
    currentUser?.comp_id || currentUser?.company_id;

  if (
    ["Techie", "Admin"].includes(currentUser?.is_admin) &&
    userCompanyId
  ) {
    setFormData(prev => ({
      ...prev,
      comp_id: userCompanyId,
    }));
  }
}, [currentUser]);



  return (
    <section className="px-3">
      <div className="d-md-flex justify-between my-3">
        <div className="d-flex">
          <i className="bx bxs-plus-circle" style={{ fontSize: "24px" }}></i>
          <p className="fw-bolder fs-big">
            {Object.keys(props.editUser).length === 0
              ? "Add New User"
              : `Edit User "${props.editUser.name}"`}
          </p>
        </div>
        <button className="add-btn" onClick={props.toggler}>
          <i
            className="bx bxs-left-arrow-circle"
            style={{ fontSize: "22px" }}
          ></i>
          &nbsp; Back to Users
        </button>
      </div>

      <div className="p-3 bg-white" >
     
        {props.editUser.image &&
<div style={{textAlign: 'center'}}>
<img src={`https://api.dectwinservices.com/uploads/${props.editUser.image}`} style={{height: '6em', borderRadius: '50%', marginTop: '1em',
  border: '3px solid var(--gray)'
}} alt="user" /></div> }


        <form className="row" onSubmit={handleSubmit}>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="staff_name">User Name</label>
            <div className="input-icon">
              <i className="bx bxs-layer"></i>
              <input
                type="text"
                name="staff_name"
                id="staff_name"
                value={formData.staff_name}
                onChange={handleChange}
                placeholder="Enter User Name"
                // disabled={props.doEdit === "Techie"}
                required
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="staff_id">User ID</label>
            <div className="input-icon">
              <i className="bx bx-id-card"></i>
              <input
                type="text"
                name="staff_id"
                id="staff_id"
                value={formData.staff_id}
                onChange={handleChange}
                placeholder="Enter User ID"
                required
                // disabled={!!props.editUser.name}
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="pass">Create Password</label>
            <div className="input-icon">
              <i className="bx bxs-lock"></i>
              <input
                type="text"
                name="pass"
                id="pass"
                value={formData.pass}
                onChange={handleChange}
                placeholder="Create Password"
                // disabled={props.doEdit === "Techie"}
                required
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="comp_id">Select Company</label>
            <div className="input-icon">
              <i className="bx bxs-user"></i>
              <select
                name="comp_id"
                id="comp_id"
                value={formData.comp_id   }
                onChange={handleChange}
                required
                disabled={["Techie", "Admin"].includes(currentUser?.is_admin)}
              >
                <option value="">Select Company</option>
                {/* {companies.map((company) => (
                  <option key={company.id} value={company.comp_id}>
                    {company.company_name}
                  </option>
                ))} */}
                 {companyOptions.map((company) => (
    <option key={company.id} value={company.comp_id}>
      {company.company_name}
    </option>
  ))}
              </select>
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="contact">User Contact</label>
            <div className="input-icon">
              <i className="bx bx-phone"></i>
              <input
                type="tel"
                name="contact"
                id="contact"
                placeholder="Enter User Contact"
                value={formData.contact}
                // disabled={props.doEdit === "Techie"}
                onChange={handleChange}
                pattern="[0-9]*"
  maxLength={10}
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="email">User Email</label>
            <div className="input-icon">
              <i className="bx bx-envelope"></i>
              <input
                type="email"
                name="email"
                id="email"
                placeholder="Enter User Email"
                value={formData.email}
                // disabled={props.doEdit === "Techie"}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="designation">User Designation</label>
            <div className="input-icon">
              <i className="bx bx-briefcase"></i>
              <input
                type="text"
                name="designation"
                id="designation"
                placeholder="Enter User Designation"
                value={formData.designation}
                // disabled={props.doEdit === "Techie"}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="department">Working Department</label>
            <div className="input-icon">
              <i className="bx bx-building"></i>
              <input
                type="text"
                name="department"
                id="department"
                placeholder="Working Department"
                value={formData.department}
                // disabled={props.doEdit === "Techie"}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="staff_type">User Role</label>
            <div className="input-icon">
              <i className="bx bxs-user-badge"></i>
              <select
                name="staff_type"
                id="staff_type"
                value={formData.staff_type}
                onChange={handleChange}
                // disabled={props.doEdit === "Techie"}
                required
              >
                <option value="">Select User Role</option>
                <option value="Admin">Admin</option>
                <option value="Employee">Employee</option>
              </select>
            </div>
          </div>

<div className="form-data col-lg-3 col-md-6 col-12">
  <label htmlFor="assigned_item">Select Assigned Item</label>
  <div className="input-icon" style={{padding: '0.25em'}}>
    <i className="bx bxs-package"></i>
    <Select
      options={unassignedItems}
      value={unassignedItems.find(opt => opt.value === formData.assigned_item)}
      onChange={(selectedOption) =>
        handleChange({
          target: { name: "assigned_item", value: selectedOption.value }
        })
      }
 styles={customStyles}      placeholder="Search & Select item"
      isSearchable
    />
  </div>
</div>


          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="assign_date">Assign Date</label>
            <div className="input-icon">
              <i className="bx bxs-calendar-check"></i>
              <input
                type="date"
                name="assign_date"
                id="assign_date"
                value={formData.assign_date}
max={new Date().toISOString().split("T")[0]}                // disabled={props.doEdit === "Admin"}
                onChange={handleChange}
              />
            </div>
          </div>


          <div className="form-data col-lg-3 col-md-6 col-12">
            <label htmlFor="priority">Set Priority</label>
            <div className="input-icon">
              <i className="bx bxs-chart"></i>
              <select
                name="priority"
                id="priority"
                value={formData.priority}
                onChange={handleChange}
                // disabled={props.doEdit === "Techie"}
                required
              >
                <option value="">Select Priority Level</option>
                <option value="1">Priority 1</option>
                <option value="2">Priority 2</option>
                <option value="3">Priority 3</option>
              </select>
            </div>
          </div>


             <div className="form-data col-lg-3 col-md-6 col-12">
              <label htmlFor="image">Upload Image</label>
              <div className="input-icon" >
                <i className="bx bxs-image"></i>
                <input
                  type="file"
                  name="image"
                  id="image"
                  onChange={handleFileChange}
                  accept="image/*"
                
                />
              </div>
            </div>


          <div className="form-data"></div>
              <div className="form-data"></div>


          <div className="btn-group d-flex mt-2" style={{ justifyContent: "end" }}>

                  <button type="submit" className="button-85">
            Submit
          </button>
              </div>

        
        </form>
      </div>
    </section>
  );
}

export default AddUsers;
